import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';

export const ScanStatusContext = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    tracking_event_id: [],
    from_user_id: null,
    to_user_id: null,
    // merchant_id: [],
    // courier_id: [],
    dateRange: {
        startDate: new Date(),
        endDate: new Date()
    },
    // type: 1,
};
const tabOptions = [
    { label: "All", value: 1 },
    { label: "Action Required", value: 2 },
    { label: "Action Requested", value: 3 },
];
export const ScanStatusContextProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allScanStatus, setAllScanStatus] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [trackingEvent, setTrackingEvent] = useState([]);
    const [formDataTemp, setFormDataTemp] = useState({
        action: '',
        file: null,
    });
    const [usersList, setUsersList] = useState([]);

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const handlePanelOpen = () => {
        setIsPanelOpen(true);
    };

    const handlePanelClose = () => {
        setIsPanelOpen(false);
        setFormDataTemp({
            action: '',
            file: null,
        });
    };


    const listEvent = () => {
        commonApi
            .post("/tracking-events/listForDropDown")
            .then((response) => {
                if (response?.data?.s === 1) {
                    setTrackingEvent(response?.data?.data);
                }
            })
            .catch((err) => console.log(err));
    };

    const fetchUsers = () => {
        const payload = { page: 1, per_page: 1000 };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id;
        }
        payload.scan_status_check = 1
        commonApi.post('/users/dropdown', payload)
            .then((response) => {
                if (response?.data?.data) {
                    setUsersList(response.data.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching users:', error);
            });
    };

    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };

        delete payload.dateRange;
        setAllData([]);
        setAllScanStatus([]);
        setFirstLoading(false);
        commonApi.post(`/orders/scanlist?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllScanStatus(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onExport = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }
        delete payload.dateRange;
        setIsLoading(true);
        commonApi.post('/orders/scanlist/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error')
            });
    };
    // Fetch initial data when the context is created
    useEffect(() => {
        onLoadApi();
        listEvent();
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab]);


    const contextValue = {
        formDataTemp,
        setFormDataTemp,
        isPanelOpen,
        handlePanelOpen,
        handlePanelClose,
        onExport,
        addModal,
        handleAddModal,
        handleCloseModal,
        initialFilters,
        allData,
        setAllData,
        allScanStatus,
        setAllScanStatus,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
        trackingEvent,
        listEvent,
        usersList,
    };
    return (
        <ScanStatusContext.Provider value={contextValue}>
            {children}
        </ScanStatusContext.Provider>
    );
};

